import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Phone, MessageCircle, Menu, X } from "lucide-react";
import { PHONE_TEL, WHATSAPP_URL } from "@/lib/constants";

const LINKS = [
  { to: "/", label: "Accueil", testid: "nav-home-link" },
  { to: "/catalogue", label: "Catalogue", testid: "nav-catalog-link" },
  { to: "/vendre", label: "Vendre ma voiture", testid: "nav-trade-in-link" },
  { to: "/contact", label: "Contact", testid: "nav-contact-link" },
];

export const BrandLogo = () => (
  <span className="leading-none">
    <span className="font-display font-black text-2xl tracking-tight text-white">
      G<span className="text-[#FF1E27]">H</span>V
    </span>
    <span className="block text-[9px] font-spec tracking-[0.35em] text-zinc-500 uppercase mt-0.5">
      Groupe Huvig
    </span>
  </span>
);

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b border-white/10 bg-black/95 md:bg-black/70 md:backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 h-16 md:h-20 flex items-center justify-between gap-4">
        <Link to="/" data-testid="nav-brand-logo" aria-label="Groupe Huvig — Accueil">
          <BrandLogo />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors duration-300 ${
                  isActive ? "text-[#FF1E27]" : "text-zinc-400 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            data-testid="nav-call-now-button"
            href={`tel:${PHONE_TEL}`}
            aria-label="Appeler le Groupe Huvig"
            className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-zinc-300 hover:text-white hover:border-[#FF1E27] transition-colors"
          >
            <Phone className="w-4 h-4" />
          </a>
          <a
            data-testid="nav-whatsapp-button"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp Groupe Huvig"
            className="h-10 px-4 rounded-full bg-[#FF1E27] text-white text-sm font-semibold flex items-center gap-2 hover:bg-[#E63946] transition-colors"
          >
            <MessageCircle className="w-4 h-4" />
            <span className="hidden sm:inline">WhatsApp</span>
          </a>
          <button
            data-testid="nav-menu-toggle"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
            className="md:hidden w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav data-testid="nav-mobile-menu" className="md:hidden border-t border-white/10 bg-black">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`${l.testid}-mobile`}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block px-6 py-4 text-base font-medium border-b border-white/5 ${
                  isActive ? "text-[#FF1E27]" : "text-zinc-300"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
}
